import { Injectable } from '@angular/core';
import { CrudService } from 'app/shared/crud-service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { EmpresaDTO } from './empresa.model';
import { DepositoDTO } from './add-deposito-form/deposito.model';
import { DepositoService } from 'app/shared/deposito.service';
import { VendedorEmpresaService } from './vendedor-empresa.service';

@Injectable({
    providedIn: 'root'
})
export class EmpresaService extends CrudService<EmpresaDTO> implements Resolve<any>{
    routeParams: any;

    constructor(protected http: HttpClient,
                private _depositoService: DepositoService,
                private _vendedoresService: VendedorEmpresaService,
        ) {
        super(http, `${environment.apiUrl}/v1/Empresa`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        if (this.routeParams.id === 'new') {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }

    createEmpresa(empresa: any): Promise<any>{
        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl}/sap/v2/BusinessPlaces`, empresa)
            .subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    updateEmpresa(empresa: any): Promise<any>{
        return new Promise((resolve, reject) => {
            this.http.put(`${environment.apiUrl}/sap/v2/BusinessPlaces`, empresa)
            .subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }    

    getByCodigoIntegracao(codigo: any){
        return new Promise((resolve, reject) => {
            this.http
                .get(`${environment.apiUrl}/v1/Empresa/CodigoIntegracao/` + codigo)
                .subscribe((response: any) => {                                                            
                    resolve(response.model);                    
                }, reject);
        });
    }

    searchERP(param: string, tipo: string): Observable<any> {            
        if (parseInt(tipo) == 2){
            return this.http.get(`${environment.apiUrl}/v1/Empresa/GetEmpresasERPPorNome/${param}`);
        }else{
            return this.http.get(`${environment.apiUrl}/v1/Empresa/GetEmpresasERPPorChave/${param}`);
        }                       
    }

    consultaCnpjExiste(cnpj): Promise<any> {                
        
        return new Promise((resolve, reject) => {
            this.http
                .get('http://localhost:5000/cnpjExiste')
                .subscribe( res => {
                    resolve(res);
                }, reject);
        });

    }

    consultaCnpjReceita(cnpj): Promise<any> {                
        
        return new Promise((resolve, reject) => {
            this.http
                .get(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`, cnpj)
                .subscribe( res => {
                    resolve(res);
                }, reject);
        });

    }
    
    getEmpresaByVendedorId(id){
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiUrl}/v1/Empresa/GetAllVendedor?VendedorId=` + id, id)
                .subscribe((response: any) => {                                       
                    resolve(response);                    
                }, reject);
        });
    }

    updateImagens(obj: any): Promise<any>{
        //console.log(obj);
        return new Promise((resolve, reject) => {
            this.http.put(`${environment.apiUrl}/v1/Empresa/AlterarTodasEmpresas`, obj)
            .subscribe((response: any) => {
                //console.log(response);
                resolve(response);
            }, reject);
        });
    }
}
